import "./LinearModel.css";

import { Fragment } from "react";
import PropTypes from "prop-types";
import { PropertyName } from "../../../../../components/PropertyName/PropertyName";

export const LinearModel = ({ model }) => {
  const [response, factors] = model.split("~");
  const factorsArray = factors.split("+");
  return (
    <div className="linear-model p-2">
      <PropertyName
        colorful
        className="font-weight-bold"
        showIcon
        technicalName={response}
      />
      <span>~</span>
      {factorsArray.map((factor, factorIndex) => (
        <Fragment key={factor}>
          {factorIndex > 0 && <span>+</span>}
          {factor.split("*").map((subfactor, index) => (
            <Fragment key={`${subfactor}${index}`}>
              {index > 0 && <span>*</span>}
              <span>
                <PropertyName showIcon technicalName={subfactor} />
              </span>
            </Fragment>
          ))}
        </Fragment>
      ))}
    </div>
  );
};

LinearModel.propTypes = {
  model: PropTypes.string.isRequired,
};
